const routes = [
  {
    path: 'atomiccss',
    name: 'atomiccss',
    component: () => import(/* webpackChunkName: "atomiccss" */ '@/modules/atomiccss/index.vue')
  },
];

export default routes;